<template>
    <nav v-if="authLogin && user" class="navbar navbar-expand-md navbar-light shadow-sm">
        <div class="custom-header">
            <div class="main-menu" tabindex="-1" v-click-outside="closeMainMenu">
                <button ref="mainMenuBtn" class="navbar-toggler d-block border-0" type="button"
                        data-bs-toggle="collapse" data-bs-target="#mainMenu" aria-controls="mainMenu"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse collapsible-menu" id="mainMenu">
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                        <li class="nav-item dropdown" @click="closeMainMenu">
                            <router-link class="dropdown-item" to="/admin/tenants">
                                <img src="/images/icons/building.svg" alt="tenant">
                                <span>Tenant Management</span>
                            </router-link>
                        </li>
                        <li class="nav-item dropdown" @click="closeMainMenu">
                            <router-link class="dropdown-item" to="/admin/pages">
                                <img src="/images/icons/book.svg" alt="page">
                                <span>Page Management</span>
                            </router-link>
                        </li>
                        <li class="nav-item dropdown" @click="closeMainMenu">
                            <router-link class="dropdown-item" to="/admin/hotel">
                                <img src="/images/icons/hotel.svg" alt="hotel">
                                <span>Hotel & Residence</span>
                            </router-link>
                        </li>
                        <li class="nav-item dropdown" @click="closeMainMenu">
                            <router-link class="dropdown-item" to="/admin/office">
                                <img src="/images/icons/office.svg" alt="office">
                                <span>Lotte Office</span>
                            </router-link>
                        </li>
                        <li class="nav-item dropdown" @click="closeMainMenu">
                            <router-link class="dropdown-item" to="/admin/family">
                                <img src="/images/icons/lotte-family.svg" alt="family">
                                <span>Lotte Family</span>
                            </router-link>
                        </li>
                        <li class="nav-item dropdown" @click="closeMainMenu">
                            <router-link class="dropdown-item" to="/admin/master-data">
                                <img src="/images/icons/document.svg" alt="master">
                                <span>Master Data</span>
                            </router-link>
                        </li>
                        <li class="nav-item dropdown" @click="closeMainMenu">
                            <router-link class="dropdown-item" to="/admin/promotions">
                                <img src="/images/icons/promotion.svg" alt="promotion">
                                <span>Promotion</span>
                            </router-link>
                        </li>
                        <li class="nav-item dropdown" @click="closeMainMenu">
                            <router-link class="dropdown-item" to="/admin/news">
                                <img src="/images/icons/notification.svg" alt="event">
                                <span>News and events</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="page-title text-center">
                {{ this.$route.meta.title }}
            </div>
            <div class="collapse navbar-collapse position-absolute button-logout"
                 tabindex="-1" v-click-outside="closeAuthMenu"
            >
                <button ref="authMenuBtn" class="navbar-toggler d-block border-0" data-bs-toggle="collapse"
                        data-bs-target="#authMenu" aria-controls="authMenu" type="button"
                        aria-expanded="false" aria-label="Toggle navigation">
                    {{ user.name }}
                </button>
                <div class="collapse collapsible-menu" id="authMenu">
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                        <li @click="closeAuthMenu">
                            <a @click="openSetting" class="dropdown-item">
                                <img src="/images/icons/account.svg" alt="user">
                                <span>Account Setting</span>
                            </a>
                        </li>
                        <li @click="closeAuthMenu">
                            <a @click="logout" class="dropdown-item">
                                <img src="/images/icons/logout.svg" alt="logout">
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <a-modal v-model:open="isSetting" :closable="false" :footer="null" class="modal-account-setting">
            <div class="section-form__edit-confirm">
                <div class="info-section col-md-12 d-flex">
                    <div class="info-text-section col-md-12">
                        <div class="mt-4 d-flex col-md-12 gap-4 align-items-center">
                            <div class="title-label col-md-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                    <g clip-path="url(#clip0_1_2372)">
                                        <path d="M31.6667 8.33333V31.6667H8.33333V8.33333H31.6667ZM31.6667 5H8.33333C6.48333 5 5 6.5 5 8.33333V31.6667C5 33.5 6.48333 35 8.33333 35H31.6667C33.5 35 35 33.5 35 31.6667V8.33333C35 6.5 33.5 5 31.6667 5ZM20 20C17.25 20 15 17.75 15 15C15 12.25 17.25 10 20 10C22.75 10 25 12.25 25 15C25 17.75 22.75 20 20 20ZM20 13.3333C19.0833 13.3333 18.3333 14.0833 18.3333 15C18.3333 15.9167 19.0833 16.6667 20 16.6667C20.9167 16.6667 21.6667 15.9167 21.6667 15C21.6667 14.0833 20.9167 13.3333 20 13.3333ZM30 30H10V27.45C10 23.2833 16.6167 21.4833 20 21.4833C23.3833 21.4833 30 23.2833 30 27.45V30ZM13.85 26.6667H26.15C25 25.7333 22.1833 24.8 20 24.8C17.8167 24.8 14.9833 25.7333 13.85 26.6667Z" fill="#323232"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1_2372">
                                            <rect width="40" height="40" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="news-form__input">
                                <label class="news-form__title">
                                    ACCOUNT NAME
                                </label>
                                <a-input :maxlength="255" v-model:value="infoUser.email"/>

                                <div v-if="sysError.email" class="invalid-feedback custom-required-logo d-inline-block">
                                    {{ sysError.email[0] }}
                                </div>
                            </div>
                        </div>
                        <div class="mt-4 d-flex col-md-12 gap-4 align-items-center">
                            <div class="title-label col-md-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                                    <mask id="mask0_2393_1203" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="34" height="34">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.333374 0.333008H33.6665V33.6663H0.333374V0.333008Z" fill="white"/>
                                    </mask>
                                    <g mask="url(#mask0_2393_1203)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.77337 2.83301C5.55837 2.83301 2.83337 5.72134 2.83337 10.193V23.8063C2.83337 28.278 5.55837 31.1663 9.77337 31.1663H24.22C28.44 31.1663 31.1667 28.278 31.1667 23.8063V10.193C31.1667 5.72134 28.44 2.83301 24.2234 2.83301H9.77337ZM24.22 33.6663H9.77337C4.12671 33.6663 0.333374 29.703 0.333374 23.8063V10.193C0.333374 4.29634 4.12671 0.333008 9.77337 0.333008H24.2234C29.8717 0.333008 33.6667 4.29634 33.6667 10.193V23.8063C33.6667 29.703 29.8717 33.6663 24.22 33.6663Z" fill="black"/>
                                    </g>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7314 15.1641C10.7147 15.1641 9.89136 15.9874 9.89136 17.0007C9.89136 18.0141 10.7147 18.8374 11.728 18.8374C12.7397 18.8374 13.5647 18.0141 13.5647 17.0007C13.5647 15.9891 12.7414 15.1657 11.7314 15.1641ZM11.728 21.3374C9.33636 21.3374 7.39136 19.3907 7.39136 17.0007C7.39136 14.6091 9.33636 12.6641 11.728 12.6641C14.123 12.6657 16.0647 14.6107 16.0647 17.0007C16.0647 19.3907 14.1197 21.3374 11.728 21.3374Z" fill="black"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.3496 21.3374C24.6596 21.3374 24.0996 20.7774 24.0996 20.0874V18.249H14.8196C14.1296 18.249 13.5696 17.6907 13.5696 16.999C13.5696 16.309 14.1296 15.749 14.8196 15.749H25.3496C26.0396 15.749 26.5996 16.309 26.5996 16.999V20.0874C26.5996 20.7774 26.0396 21.3374 25.3496 21.3374Z" fill="black"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.6359 21.3374C19.9459 21.3374 19.3859 20.7774 19.3859 20.0874V16.999C19.3859 16.309 19.9459 15.749 20.6359 15.749C21.3259 15.749 21.8859 16.309 21.8859 16.999V20.0874C21.8859 20.7774 21.3259 21.3374 20.6359 21.3374Z" fill="black"/>
                                </svg>
                            </div>
                            <div class="news-form__input">
                                <label class="news-form__title">
                                    ACCOUNT PASSWORD
                                </label>
                                <a-input-password :maxlength="255" placeholder="********" v-model:value="infoUser.password"/>
                            </div>
                        </div>
                        <div class="mt-4 d-flex col-md-12 gap-4 align-items-center">
                            <div class="title-label col-md-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9167 12.5003C12.9167 8.58831 16.088 5.41699 20 5.41699C23.9121 5.41699 27.0834 8.58831 27.0834 12.5003C27.0834 16.4123 23.9121 19.5837 20 19.5837C16.088 19.5837 12.9167 16.4123 12.9167 12.5003ZM20 7.91699C17.4687 7.91699 15.4167 9.96902 15.4167 12.5003C15.4167 15.0316 17.4687 17.0837 20 17.0837C22.5313 17.0837 24.5834 15.0316 24.5834 12.5003C24.5834 9.96902 22.5313 7.91699 20 7.91699Z" fill="black"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3334 24.5837C11.2623 24.5837 9.58337 26.2626 9.58337 28.3337V30.3141C9.58337 30.3443 9.60523 30.37 9.63499 30.3749C16.4996 31.4956 23.5005 31.4956 30.3651 30.3749C30.3949 30.37 30.4167 30.3443 30.4167 30.3141V28.3337C30.4167 26.2626 28.7378 24.5837 26.6667 24.5837H26.0986C26.0547 24.5837 26.011 24.5906 25.9693 24.6042L24.5267 25.0753C21.5854 26.0357 18.4147 26.0357 15.4733 25.0753L14.0308 24.6042C13.9891 24.5906 13.9454 24.5837 13.9015 24.5837H13.3334ZM7.08337 28.3337C7.08337 24.8819 9.88159 22.0837 13.3334 22.0837H13.9015C14.209 22.0837 14.5145 22.1323 14.8068 22.2277L16.2494 22.6988C18.6865 23.4946 21.3136 23.4946 23.7507 22.6988L25.1933 22.2277C25.4856 22.1323 25.7911 22.0837 26.0986 22.0837H26.6667C30.1185 22.0837 32.9167 24.8819 32.9167 28.3337V30.3141C32.9167 31.5695 32.0069 32.6399 30.7679 32.8422C23.6365 34.0065 16.3635 34.0065 9.23216 32.8422C7.99318 32.6399 7.08337 31.5695 7.08337 30.3141V28.3337Z" fill="black"/>
                                </svg>
                            </div>
                            <div class="news-form__input">
                                <label class="news-form__title">
                                    USER NAME
                                </label>
                                <a-input :maxlength="255" v-model:value="infoUser.user_name"/>
                                <div v-if="sysError.user_name" class="invalid-feedback custom-required-logo d-inline-block">
                                    {{ sysError.user_name[0] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="news-form__delete-confirm-btn-group text-center mt-4">
                    <button class="btn btn-danger" type="button" @click="isSetting = false">
                        Cancel
                    </button>
                    <button style="margin-left: 1rem" class="btn btn-success" type="button" @click="updateUser">
                        Update
                    </button>
                </div>
            </div>
        </a-modal>
    </nav>
</template>

<script>
import {mapActions} from 'vuex'
import QuillEditorWithUpload from "./reusable/QuillEditorWithUpload.vue";
import CustomUploadTenant from "./reusable/CustomUploadTenant.vue";
import {useToast} from "vue-toastification";

export default {
    name: "TopNav",
    setup() {
        const toast = useToast();

        return {toast}
    },
    components: {CustomUploadTenant, QuillEditorWithUpload},
    created() {
        this.user = this.$store.state.auth.user;
        this.authLogin = this.$store.state.auth.authenticated
        this.infoUser.email = this.user.email
        this.infoUser.user_name = this.user.name
    },
    data() {
        return {
            user: '',
            authLogin: false,
            isSetting: false,
            infoUser: {
                email: '',
                password: '',
                user_name: ''
            },
            sysError: {}
        }
    },
    methods: {
        ...mapActions({
            signOut: "auth/logout"
        }),
        closeMainMenu() {
            // focusout the main menu will close the menu
            if (document.getElementById('mainMenu').classList.contains('show')) {
                this.$refs.mainMenuBtn.click()
            }
        },
        closeAuthMenu() {
            // focusout the auth menu will close the menu
            if (document.getElementById('authMenu').classList.contains('show')) {
                this.$refs.authMenuBtn.click()
            }
        },
        logout() {
            let that = this
            axios.post('/admin/logout').then(response => {
                if (response.status == 200) {
                    that.user = {}
                    that.authLogin = false
                    that.signOut()
                    that.$router.push({name: "admin.login"}).then(() => {
                        that.$router.go()
                    })
                }
            })
        },
        openSetting() {
            this.isSetting = !this.isSetting
        },
        updateUser() {
            let that = this
            let data = new FormData()
            let infoUser = this.infoUser

            for (let key in infoUser) {
                data.append(key, infoUser[key]);
            }

            data.append("_method", "PUT")
            axios.post('/admin/updateUser',  data).then(response => {
                if (response.data.result) {
                    that.isSetting = false
                    that.toast.success('Update Successfully', {
                        position: "top-right",
                        timeout: 3000,
                        closeOnClick: true,
                        pauseOnFocusLoss: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 0.6,
                        showCloseButtonOnHover: false,
                        hideProgressBar: true,
                        closeButton: "button",
                        icon: true,
                        rtl: false
                    });
                } else {
                    console.log(response)
                    this.sysError = response.data.error
                }
            }).catch((error) => {
                that.toast.error("An error has occurred!", {
                    position: "top-right",
                    timeout: 3000,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: true,
                    closeButton: "button",
                    icon: true,
                    rtl: false
                });
            });
        }
    }
}
</script>
<style>
.modal-account-setting {
    width: 400px;
}
</style>
